import { AppRoutes } from '../../constants/appRoutes';
import { entityNames } from '../../constants/entities';
import { EDetailsQueryNames } from '../../constants/queryNames';
import { OptionSet } from '../../models/stack9/OptionSet';
import { EntityDrawer } from '../EntityDrawer/EntityDrawer';

type OptionSetDrawerProps = {
  open: boolean;
  onClose: () => void;
  id?: number;
  initialValues?: Partial<OptionSet>;
};

export const OptionSetDrawer = ({
  open,
  onClose,
  id,
  initialValues,
}: OptionSetDrawerProps) => {
  const formFields = [
    { field: 'sequence', colSize: 12 },
    { field: 'is_correct', colSize: 12 },
    { field: 'option' },
    { field: 'negative_response' },
    { field: 'lang_set' },
    { field: 'negative_response_lang_set' },
    { field: 'is_active' },
  ];

  return (
    <EntityDrawer
      title="option set"
      formFields={formFields}
      initialValues={initialValues}
      id={id}
      open={open}
      onClose={onClose}
      screenQueryName={EDetailsQueryNames.GetOptionSetDetails}
      entityName={entityNames.OPTION_SET}
      editRoute={AppRoutes.RequirementDetail}
      relativePath={AppRoutes.RequirementDetail}
    />
  );
};
